import fetch, { parseListResponse, parseResponse } from "./fetch";

export interface TypeMarqueInterface {
    id: string;
    libel: string;
}

class TypeMarque {
    all(params?: HashMap<any>) {
        return parseListResponse<TypeMarqueInterface>(fetch.get(`type_marques/liste/`, { params }));
    }

    one(id: string) {
        return parseResponse<TypeMarqueInterface>(fetch.get(`type_marques/${id}`));
    }
}

export default new TypeMarque();
